// extracted by mini-css-extract-plugin
export default {"DetailsButton":"UserPatients_DetailsButton__3uOR6"};